import React from 'react';
import style from './style.css';

const Benchmark = props => {
    const { sessionsMetBenchmark, totalSessions } = props.data;
    const { colors } = props;

    return (
        <div className={style.wrapper} style={colors ? { color: colors.primary } : {}}>
            {sessionsMetBenchmark} out of {totalSessions}
        </div>
    );
};

export default Benchmark;
